import React from 'react';

function LinkedinIcon({size}: {size: number}) {
	return (
		<svg fill="white" width={size} height={size} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			 viewBox="0 0 512 512" xmlSpace="preserve">
<g>
	<g>
		<path d="M503.983,92.994c4.428,0,8.017-3.589,8.017-8.017V42.221C512,18.941,493.059,0,469.779,0H42.221
			C18.941,0,0,18.941,0,42.221v427.557C0,493.059,18.941,512,42.221,512h427.557C493.059,512,512,493.059,512,469.779V119.182
			c0-4.427-3.588-8.017-8.017-8.017c-4.428,0-8.017,3.589-8.017,8.017v350.597c0,14.44-11.747,26.188-26.188,26.188H42.221
			c-14.44,0-26.188-11.748-26.188-26.188V42.221c0-14.44,11.748-26.188,26.188-26.188h427.557c14.441,0,26.188,11.748,26.188,26.188
			v42.756C495.967,89.405,499.555,92.994,503.983,92.994z"/>
	</g>
</g>
			<g>
	<g>
		<path d="M153.386,238.898c4.427,0,8.017-3.589,8.017-8.017v-34.739c0-4.427-3.589-8.017-8.017-8.017H84.977
			c-4.427,0-8.017,3.589-8.017,8.017v230.881c0,4.427,3.589,8.017,8.017,8.017h68.409c4.427,0,8.017-3.589,8.017-8.017V266.154
			c0-4.427-3.589-8.017-8.017-8.017s-8.017,3.589-8.017,8.017v152.852H92.994V204.159h52.376v26.722
			C145.37,235.308,148.959,238.898,153.386,238.898z"/>
	</g>
</g>
			<g>
	<g>
		<path d="M408.05,210.086c-16.319-13.956-37.454-21.96-57.987-21.96c-33.891,0-55.359,11.268-68.944,25.151v-17.134
			c0-4.427-3.588-8.017-8.017-8.017h-68.409c-4.427,0-8.017,3.589-8.017,8.017v230.881c0,4.427,3.589,8.017,8.017,8.017h68.409
			c4.428,0,8.017-3.589,8.017-8.017V315.858c0-21.457,18.032-34.739,34.739-34.739c20.129,0,34.739,14.61,34.739,34.739v111.165
			c0,4.427,3.588,8.017,8.017,8.017h68.409c4.428,0,8.017-3.589,8.017-8.017V264.551C435.04,244.315,425.454,224.972,408.05,210.086
			z M419.006,419.006H366.63V315.858c0-28.946-21.828-50.772-50.772-50.772c-24.418,0-50.772,19.412-50.772,50.772v103.148H212.71
			V204.159h52.376v34.739c0,3.656,2.573,6.926,6.125,7.789c3.66,0.888,7.55-0.973,9.15-4.385
			c11.871-25.31,35.323-38.143,69.703-38.143c32.545,0,68.944,25.828,68.944,60.392V419.006z"/>
	</g>
</g>
			<g>
	<g>
		<path d="M119.182,76.96c-23.281,0-42.221,18.941-42.221,42.221s18.941,42.221,42.221,42.221s42.221-18.941,42.221-42.221
			S142.462,76.96,119.182,76.96z M119.182,145.37c-14.44,0-26.188-11.748-26.188-26.188s11.748-26.188,26.188-26.188
			s26.188,11.748,26.188,26.188S133.621,145.37,119.182,145.37z"/>
	</g>
</g>
			<g>
</g>
			<g>
</g>
			<g>
</g>
			<g>
</g>
			<g>
</g>
			<g>
</g>
			<g>
</g>
			<g>
</g>
			<g>
</g>
			<g>
</g>
			<g>
</g>
			<g>
</g>
			<g>
</g>
			<g>
</g>
			<g>
</g>
</svg>
	)
}

export default LinkedinIcon;
